import React, { Component, Fragment } from 'react';
import { Mutation } from 'react-apollo';
import gql from 'graphql-tag';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faMinusCircle } from '@fortawesome/fontawesome-pro-light';
import { parsePhoneNumber } from 'libphonenumber-js';
import Dialog from 'material-ui/Dialog';

import PhoneInput from './PhoneInput';
import SmsButtonGroup from './SmsButtonGroup';

class SmsInvite extends Component {
  constructor(props) {
    super(props);
    this.state = {
      referrals: [{ name: '', mobile: '' }, { name: '', mobile: '' }],
      errorList: [],
      isDialogOpen: false,
    };
  }

  handleOnChange = ({ name, value }, i) => {
    this.setState(({ referrals }) => ({
      referrals: [...referrals.slice(0, i), { ...referrals[i], [name]: value }, ...referrals.slice(i + 1)],
    }));
  };

  addPhoneInput = () =>
    this.setState(({ referrals }) => ({
      referrals: [...referrals, { name: '', mobile: '' }],
    }));

  addError = idx => this.setState(({ errorList }) => ({ errorList: [...errorList, idx] }));

  removePhoneInput = i =>
    this.setState(({ referrals }) => ({
      referrals: [...referrals.slice(0, i), ...referrals.slice(i + 1)],
    }));

  subtractError = idx => {
    const index = this.state.errorList.indexOf(idx);
    if (index === -1) return;
    this.setState(({ errorList }) => ({
      errorList: [...errorList.slice(0, index), ...errorList.slice(index + 1)],
    }));
  };

  filterMobiles = referrals =>
    referrals
      .map(({ name, mobile }) => {
        try {
          const _mobile = parsePhoneNumber(mobile, 'CA');
          if (_mobile.isValid()) return { name, mobile };
        } catch (error) {
          // Nothing
        }
        return null;
      })
      .filter(Boolean); // filters out falsey values, specifically undefined

  handleAfterSend = () => {
    if (this.filterMobiles(this.state.referrals).length) {
      this.setState(
        {
          referrals: [{ name: '', mobile: '' }, { name: '', mobile: '' }],
        },
        this.openDialog
      );
    }
  };

  openDialog = () => this.setState({ isDialogOpen: true });
  closeDialog = () => this.setState({ isDialogOpen: false });

  render() {
    const { referrals, isDialogOpen } = this.state;
    return (
      <Mutation
        mutation={REFER_USERS}
        variables={{ referrals: this.filterMobiles(referrals) }}
        onCompleted={this.handleAfterSend}>
        {referUsers => (
          <Fragment>
            <div className="invite__container">
              <div className="invite__input-container">
                {referrals.map(({ mobile, name }, i) => (
                  /* eslint-disable-next-line react/no-array-index-key */
                  <div className="invite__input-group" key={i}>
                    <input
                      className="invite__phone-input false form-control"
                      placeholder="Name"
                      name="name"
                      type="text"
                      onChange={({ target }) => this.handleOnChange(target, i)}
                      value={name}
                    />
                    <div className="invite__phone-group">
                      <PhoneInput
                        onChange={value => this.handleOnChange({ name: 'mobile', value }, i)}
                        index={mobile}
                        value={mobile}
                        addError={this.addError}
                        subtractError={this.subtractError}
                      />
                      <FontAwesomeIcon
                        icon={faMinusCircle}
                        onClick={() => {
                          this.removePhoneInput(i);
                          this.subtractError(mobile);
                        }}
                        className={`invite__minus-btn${i <= 0 ? ' invisible' : ''}`}
                      />
                    </div>
                  </div>
                ))}

                <SmsButtonGroup referUsers={referUsers} addPhoneInput={this.addPhoneInput} />
              </div>
            </div>
            <Dialog
              open={isDialogOpen}
              actions={
                <div className="buttons-div">
                  <button type="button" className="alert-button" onClick={this.closeDialog}>
                    CLOSE
                  </button>
                </div>
              }>
              <h3 className="text-center">Invite sent!</h3>
            </Dialog>
          </Fragment>
        )}
      </Mutation>
    );
  }
}

export default SmsInvite;

const REFER_USERS = gql`
  mutation referUsers($referrals: [ReferralAttributes!]!) {
    referUsers(referrals: $referrals) {
      failures
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/Referral/SmsInvite.js